export default "__VITE_ASSET__de08f6da__"